const numberFormatter = new Intl.NumberFormat();

// A label / value row used inside the user and matter stats popovers.
export function StatRow({ label, value }: { label: string; value?: number }) {
  return (
    <div className="flex items-center justify-between py-1">
      <span className="text-sm text-gray-500">{label}</span>
      {value === undefined ? (
        <span className="block h-4 w-8 animate-pulse rounded bg-gray-200" />
      ) : (
        <span className="text-sm font-semibold text-gray-900 tabular-nums">{numberFormatter.format(value)}</span>
      )}
    </div>
  );
}
